import Vue from "vue";
import Vuex from "vuex";
import config from "@/config";
import Panier from "@/store/panier";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    Panier,
  },
  state: {
    user: {
      "id":-1,
      "username":"",
      "email":"",
      "is_staff":false,
      "avatar":"https://api-numerique.lde.fr/media/uploads/avatars/bmp_24.png",
      "avatar_from_library":null,
      "liste_courante":-1,
      "contact":{
        "id":-1,
        "prenom":"",
        "nom":"",
        "fonction_4d":"",
        "email":"",
        "tel":"",
        "genre":null
      },
      "role":""
    },
    accessForbidden: false,
    errorStatus: null,
    country: null,
    isLogged: true,
    etablissementActuel: {
      value: -1,
    }
  },
  getters: {
    user(state) {
      return state.user;
    },
    accessForbidden(state) {
      return state.accessForbidden;
    },
    errorStatus(state) {
      return state.errorStatus;
    },
    country(state) {
      return state.country;
    },
    hasPerm(state, perm) {
      return true;
    },
    isLogged(state) {
      return state.isLogged;
    },
    organismeActuel(state) {
      return state.organismeActuel;
    },
    urlHotline(state) {
      let url = `${config.urlFr.hotlineTicket}?categorie=33`; // https://hotline.lde.fr/scenarisation/viewer/

      const id = state.Organisme?.organismeActuel?.id_organisme;

      if (id) {
        url += `&id_client=${id}`;
      }

      return url;
    },
  },
  mutations: {
    setAccessForbidden(state, accessForbidden) {
      state.accessForbidden = accessForbidden;
    },
    setErrorStatus(state, errorStatus) {
      state.errorStatus = errorStatus;
    },
    setCookies(state, cookies) {
      state.user.cookies = cookies;
    },
    setCountry(state, country) {
      state.country = country || "fr";
    },
    updatePreferences(state, preferences) {
      state.preferences = { ...state.preferences, ...preferences };
      localStorage.setItem("preferences", JSON.stringify(state.preferences));
    },
  },
  actions: {
    login(store) {
      // Sentry.init();
      // Sentry.setScope();
      store.commit("setCountry", process.env.VUE_APP_COUNTRY);

      store.dispatch("initPanier");

      // Récupération de l'établissement actuel dans le localStorage
      store.dispatch("setEtablissementActuel", JSON.parse(localStorage.getItem("etablissementActuel")));

      return true;
    },
    setEtablissementActuel(store, etablissementActuel) {
      const ea = etablissementActuel ?? { value: -1 };
      store.state.etablissementActuel = ea;
      localStorage.setItem("etablissementActuel", JSON.stringify(ea));

      if (ea.value === -1) store.dispatch("clearPanier");
    }
  }
});
